import { useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as fbSignOut,
  type User,
} from "firebase/auth";
import { auth, googleProvider } from "../lib/firebase";

/**
 * Subscribe to Firebase Auth state. Returns the current User (or null) plus
 * the four sign-in actions.
 *
 * `loading` is true while Firebase rehydrates the session from IndexedDB on
 * first mount — UI should avoid showing "logged out" prematurely while this
 * is true, otherwise the avatar flickers from "Sign in" → real user.
 */
export function useAuth() {
  const [user, setUser] = useState<User | null>(auth.currentUser);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  return {
    user,
    loading,
    signInWithGoogle: () => signInWithPopup(auth, googleProvider),
    signInWithEmail: (email: string, password: string) =>
      signInWithEmailAndPassword(auth, email, password),
    registerWithEmail: (email: string, password: string) =>
      createUserWithEmailAndPassword(auth, email, password),
    signOut: () => fbSignOut(auth),
  };
}
